<template>
    <div class="preview-slot">
        <div v-if="!selectedTemplate" class="alert alert-warning m-1 text-center">
            <strong>Selecione um template no botão abaixo</strong>
        </div>
        <div v-else class="template-preview">
            <span v-html="selectedTemplate"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selectedTemplate: {
            type: String,
            default: ""
        }
    },
    methods: {

    }
}
</script>

<style scoped>
.preview-slot {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 38vh;
    width: 100%;
    overflow-y: auto;
    background: repeat url(/images/background-wpp.png) #e6ded5;
    background-size: 80%;
    background-blend-mode: soft-light;
}

.template-preview {
    width: 60%;
    align-self: flex-start;
    text-align: start;
    margin: 10px;
    background-color: white;
    padding: 5px;
    border-radius: 5px;
}
</style>
